import fetch from '../../../services/fetch-api.service';

const fetchTowns = ({ filters, page, sortField, sortOrder, limit }) => fetch.get('admin/towns/list', { filters, page, sortField, sortOrder, limit });

export default {
  fetchTowns,
};
